import { render } from "./RestaurantPaymentConfirmation.vue?vue&type=template&id=fa7ab4be&scoped=true&ts=true"
import script from "./RestaurantPaymentConfirmation.vue?vue&type=script&lang=ts"
export * from "./RestaurantPaymentConfirmation.vue?vue&type=script&lang=ts"

import "./RestaurantPaymentConfirmation.vue?vue&type=style&index=0&id=fa7ab4be&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa7ab4be"]])

export default __exports__